// src/components/FiltroBar/FiltroBar.jsx
import React, { useState, useEffect } from "react";
import "./FiltroBar.css";

export default function FiltroBar({
  campos,              // [{ value, label }]
  campoSelecionado,
  onCampoChange,
  textoFiltro,         // valor já APLICADO (modo simples)
  onTextoChange,       // callback pra aplicar/limpar (modo simples)
  onAdicionarClick,
  addLabel = "+ Adicionar",
  placeholder = "Digite para filtrar...",
  mostrarAdicionar = true,

  // 🔽 MODO AVANÇADO (multi-filtros) – OPCIONAL
  filtros,             // [{ campo, valor }]
  onFiltrosChange,     // callback pra atualizar lista de filtros
}) {
  // valor digitado no input (ainda não aplicado)
  const [valorDigitado, setValorDigitado] = useState(textoFiltro || "");

  const usandoMulti = Array.isArray(filtros) && typeof onFiltrosChange === "function";

  // Sincroniza APENAS quando o filtro aplicado é limpo
  useEffect(() => {
    if (usandoMulti) {
      // no modo multi, o textoFiltro é opcional - se ele for limpo, limpamos também o input
      if (!textoFiltro) {
        setValorDigitado("");
      }
    } else {
      // modo simples: só copiamos quando o filtro aplicado está vazio,
      // pra não acontecer de voltar o texto depois de aplicar.
      if (!textoFiltro) {
        setValorDigitado("");
      }
    }
  }, [textoFiltro, usandoMulti]);

  const temFiltroSimples = textoFiltro && textoFiltro.trim().length > 0;
  const temMultiFiltros = usandoMulti && filtros.length > 0;

  const aplicarFiltro = () => {
    const valor = (valorDigitado || "").trim();
    if (!valor) return;

    if (usandoMulti) {
      // 🔹 Modo multi: adiciona um novo item na lista de filtros
      const novoFiltro = { campo: campoSelecionado, valor };
      const novos = [...filtros, novoFiltro];
      onFiltrosChange(novos);
      if (onTextoChange) onTextoChange(""); // opcional, só pra manter compatível
    } else {
      // 🔹 Modo simples (como em Usuários)
      onTextoChange && onTextoChange(valor);
    }

    // Depois de aplicar, limpamos o campo de digitação
    setValorDigitado("");
  };

  const limparFiltro = () => {
    // limpa tudo
    setValorDigitado("");
    if (usandoMulti) {
      onFiltrosChange([]);
    }
    if (onTextoChange) onTextoChange("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      aplicarFiltro();
    }
  };

  const removerFiltroIndex = (index) => {
    if (!usandoMulti) return;
    const novos = filtros.filter((_, i) => i !== index);
    onFiltrosChange(novos);
  };

  const labelCampo = (value) => {
    const campo = campos.find((c) => c.value === value);
    return campo ? campo.label : value;
  };

  return (
    <div className="filtro-wrapper">
      <div className="filtro-bar">
        {/* Combo de campos */}
        <label className="filtro-label">
          <span>Filtrar por:</span>
          <select
            className="filtro-select"
            value={campoSelecionado}
            onChange={(e) => onCampoChange(e.target.value)}
          >
            {campos.map((c) => (
              <option key={c.value} value={c.value}>
                {c.label}
              </option>
            ))}
          </select>
        </label>

        {/* Input de texto */}
        <div className="filtro-input-wrapper">
          <input
            type="text"
            className="filtro-input"
            placeholder={placeholder}
            value={valorDigitado}
            onChange={(e) => setValorDigitado(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>

        {/* Botão aplicar */}
        <button
          type="button"
          className="filtro-aplicar-btn"
          onClick={aplicarFiltro}
        >
          Aplicar
        </button>

        {/* Botão opcional (ex: + Novo) */}
        {mostrarAdicionar && onAdicionarClick && (
          <button
            type="button"
            className="filtro-add-btn"
            onClick={onAdicionarClick}
          >
            {addLabel}
          </button>
        )}
      </div>

      {/* “Pílulas” de filtros ativos */}
      {usandoMulti ? (
        temMultiFiltros && (
          <div className="filtro-pills-container">
            {filtros.map((f, index) => (
              <div key={`${f.campo}-${index}`} className="filtro-ativo-pill">
                <span className="filtro-pill-text">
                  <strong>{labelCampo(f.campo)}:</strong> {f.valor}
                </span>
                <button
                  type="button"
                  onClick={() => removerFiltroIndex(index)}
                  className="filtro-pill-close"
                >
                  ×
                </button>
              </div>
            ))}

            {filtros.length > 1 && (
              <button
                type="button"
                className="filtro-clear-all-btn"
                onClick={limparFiltro}
              >
                Limpar todos
              </button>
            )}
          </div>
        )
      ) : (
        temFiltroSimples && (
          <div className="filtro-pills-container">
            <div className="filtro-ativo-pill">
              <span className="filtro-pill-text">
                Filtro ativo: <strong>{textoFiltro}</strong>
              </span>
              <button
                type="button"
                onClick={limparFiltro}
                className="filtro-pill-close"
              >
                ×
              </button>
            </div>
          </div>
        )
      )}
    </div>
  );
}
